<template>
  <b-button
    class="consent-settings"
    @click="consentButton"
    squared
    variant="outline"
  >
    <b-icon-gear></b-icon-gear>
  </b-button>
</template>

<script>
export default {
  name: "ConsentButton",
  methods: {
    consentButton() {
      this.$emit("clickButton");
    },
  },
};
</script>

<style lang="scss" scoped>
.consent-settings {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 60px;
  padding: 10px;
  margin: 0 0.2em 0 0;
  color: #192e5b !important;
  border: 2px solid #192e5b;
  border-top-right-radius: 50% !important;
  background-color: $secondary;
  z-index: 1;
  transform: scale(0.7);
  transform-origin: bottom left;
  transition: all 0.3s ease;

  &:hover, &:focus {
    transform: scale(1);
  }
}

.consent-settings svg {
  font-size: 35px !important;
  margin-top: 2px;
  margin-left: -2px;

  &:hover, &:focus {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    transition-duration: 0.8s;
    transition-property: transform;
  }
}
</style>